(function ($, Drupal, once) {

    'use strict';
  
    Drupal.behaviors.reftooltip = {
      attach: function (context, settings) {

        //$('.ref', context).once('mdtReftooltip').each(function () {
        once('mdtReftooltip',".ref",context).forEach(function (value,i) { 
            let svgclose = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="58" height="58" viewBox="0 0 58 58"><defs>'+
                        +'<filter id="prefix__a" width="172.5%" height="172.5%" x="-36.2%" y="-31.2%" filterUnits="objectBoundingBox"><feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4.5"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.101671766 0"></feColorMatrix></filter>'+
                        +'<circle id="prefix__b" cx="20" cy="20" r="20"></circle></defs><g fill="none" transform="translate(9 7)">'+
                        +'<use fill="#000" filter="url(#prefix__a)" xlink:href="#prefix__b"></use><use fill="#FFF" xlink:href="#prefix__b"></use><path fill="#001E46" d="M22 12L18 12 18 18 12 18 12 22 18 22 18 28 22 28 22 22 28 22 28 18 22 18z" transform="rotate(45 20 20)"></path></g></svg>';
            $('.ref').each(function () {
                
                let idref = 'ref-' + $(this).data('ref');
                if ($('#'+idref).length > 0) {
                    $(this).tooltip(
                    {
                        animated:'fade',
                        html:true,
                        trigger:'hover click',
                        title:'<div class="text-left">' + $('#'+idref).html() + '</div>',
                        delay:{ "show": 100, "hide": 150 }
                    });

                   /* $(this).click(function(){
                        let refacc = $('#'+idref).parents('.collapse');
                        if (refacc.length > 0 && !refacc.hasClass('show')) {
                            refacc.collapse('show').promise().done(function(){ scrollToBlock(idref); });                    
                        } else {
                            scrollToBlock(idref);  
                        }                     
                    });*/
                }
                $('.ref').on('click', function () {
                    var toolTipId = $(this).attr('aria-describedby');
                    $('.tooltip').not('#'+ toolTipId).tooltip('hide');
                });

                /*$('.ref').on('shown.bs.tooltip', function (e) {
                    //Auto hide after 10 seconds
                    setTimeout(function () {
                        $(e.target).tooltip('hide');
                    }, 7000);
                });*/

                document.addEventListener("click", (args) => {
                    if (!(args.target.classList.contains('ref') || args.target.closest('.ref') || args.target.closest('.tooltip'))) {                             
                        $('.tooltip').tooltip('hide');                    
                    } 
                });

            });
        });        
      }
    } 
  
  })(jQuery, Drupal, once);